module.exports = __webpack_public_path__ + "static/media/fyf.d73d50ba.jpg";